import { useState } from "react";

import CrossInCircle from "shared/assets/svg/cross-in-circle.svg?react";
import { Button } from "shared/ui/button";

import errorSvg from "../assets/error.svg";

type Props = {
  error: Error;
  onClose: () => void;
};

export const ErrorComponent = (props: Props) => {
  const { error, onClose } = props;
  const [showDetails, setShowDetails] = useState(false);
  return (
    <>
      <img src={errorSvg} className="h-[111px]" alt="error" />
      <h2 className="mt-5 text-center text-[21px] font-semibold whitespace-pre-line">
        {`Certificate Issue Error`}
      </h2>

      <div className="border-red mt-5 mb-5 flex flex-col items-center justify-center rounded-xl border-2 bg-[#FFF0F0] p-5">
        <CrossInCircle className="size-9" />
        <p className="text-balticSea mt-2.5 text-center leading-6 font-medium">
          Something went wrong during certificate issuance
        </p>

        <p className="text-red/80 mt-3">
          {showDetails ? `Error: ${error.message}` : undefined}
        </p>

        <button
          className="text-red mt-2 text-center underline"
          onClick={() => {
            setShowDetails(!showDetails);
          }}
        >
          {showDetails ? "Hide details" : "Show details"}
        </button>
      </div>

      <Button className="mt-auto w-full" onClick={onClose}>
        Close
      </Button>
    </>
  );
};
